import React from "react";
import { deleteExerciseFromProgram,
         deleteDayFromProgram
        } from "../utils/Object";
import groupBy  from 'lodash/groupBy';
var uuidv1 = require('uuid/v1');

export const sortWeekObjectFromMonthView = (programObj, sorted_week_order, week_id_to, week_id_from, sorted_week_id, new_index) => {
    var ctr    = 0;
    var n_ctr  = 0;
    var tmpObj = [];//programObj;

    console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<< SORT WEEK OBJECT function >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    console.log("sorted_week_order: " + sorted_week_order);
    //// CONVERT OBJECT INTO ARRAY TO SORT AND THEN CONVERT BACK OUT
    //// LOOP AND REMOVE THE SORTED BLOCKS/ELEMENTS ////
    for(var key in programObj) {
            var value        = programObj[key];
            var week_id      = value.week_id;
            //var week_order   = value.week_order;
            var day_order    = value.day_order;
            var day_id       = value.day_id;
            var block_order  = value.block_order;
            var block_name   = "";
            var exercise     = value.exercise;
            var block_id     = value.block_id;
            var exercise_lgth  = value.exercise_lgth;
            var new_week_order = sorted_week_order.indexOf(week_id) + 1;

            //// COPY EXISTING BLOCKS IN A MATCHING DAY ////
            tmpObj[n_ctr] = {};
            tmpObj[n_ctr].week_id       = week_id;
            tmpObj[n_ctr].week_order    = new_week_order; //week order starts at 1, not 0;
            tmpObj[n_ctr].day_id        = day_id;   //change when day sprted >> add new day id
            tmpObj[n_ctr].day_order     = day_order; // since day orders start @ 1
            tmpObj[n_ctr].block_order   = block_order;
            tmpObj[n_ctr].block_id      = block_id;
            tmpObj[n_ctr].block_name    = block_name;
            //tmpObj[n_ctr].exercise      = exercise;
            tmpObj[n_ctr].exercise_lgth = exercise_lgth;
            tmpObj[n_ctr].exercise   = {};
            //console.log("day_id: " + day_id);

            for(var key1 in exercise) {
                var exer        = exercise[key1];
                var exer_name   = exer.name;
                var exer_id     = exer.id;
                var set_id      = exer.set_id;
                var exer_order  = exer.order;
                //console.log(key1 + ". exer_name: " + exer_name);
                tmpObj[n_ctr].exercise[key1]        = {};
                tmpObj[n_ctr].exercise[key1].id     = exer_id;
                tmpObj[n_ctr].exercise[key1].name   = exer_name;
                tmpObj[n_ctr].exercise[key1].set_id = set_id;
                tmpObj[n_ctr].exercise[key1].order  = exer_order;

                /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
            }
    //        console.log("---------------");
            n_ctr++;
    }
    console.log(" -- End SORT WEEK OBJECT function --");
    tmpObj = tmpObj.sort(propSorter(['week_order','day_order','block_order']));
    //console.log("================================");
    //testKeys(tmpObj);

    return tmpObj;
}

function setNewSortDayArray(programObj, week_id_to, sorted_days_order, day_to_index, new_day_id) {
    var day_arr     = [];
    var sorted_flag = false;
    var match_week_id;
    var match_week_order;
    var match_day_id;
    var match_day_order;
    var match_block_id;
    var match_block_order;
    var matchObj = {};


    //// COMPARE BLOCK IDS AND SORT NEW EXERCISE ORDERS
    for(var key in programObj) {
            var value        = programObj[key];
            var day_id       = value.day_id;
            var week_id      = value.week_id;
            var block_id     = value.block_id;
            var exercise     = value.exercise;

            // fetch the week, day and block data
            if(week_id === week_id_to) {
                matchObj.match_week_id     = value.week_id;
                matchObj.match_week_order  = value.week_order;
                matchObj.match_day_id      = day_id;
                //matchObj.match_day_order   = value.day_order;
                //matchObj.match_block_id    = block_id_to;
                matchObj.match_block_order = value.block_order;
                //sorted_flag = true;
            }
    }

    //// If the newly sorted exercise is placed as the last exercise in a Block and not inserted above ////
    //if(!sorted_flag) {
        //day_arr.push([new_set_id, new_exer_id, new_exer_name, exercise_to_index])
    //}
    matchObj.day_arr = day_arr;
    matchObj.sorted_flag = sorted_flag;

    return matchObj;
}

//// GET Index of a Multidimensional Array ////
function getIndexOfK(arr, k) {
    for (var i = 0; i < arr.length; i++) {
        var index = arr[i].indexOf(k);
        if (index > -1) {
          return [i, index];
        }
    }
}

export const sortBlockObjectFromDayView = (programObj, sorted_blocks_exercs_order_arr, sorted_blocks_order, sorted_exercise_order, day_id_to) => {
        var n_ctr;
        var tmpObj = [];
        var match_week_id;
        var match_week_order;
        var match_day_order;
        var total_block_and_exerc_lgth = sorted_blocks_exercs_order_arr.length;
        var tmp_exerc_arr = [];

        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<< SORT BLOCK OBJECT function >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
        //console.log("blocks_order: " + sorted_blocks_order);
        //console.log("total_block_exerc_lgth: " + total_block_and_exerc_lgth);

        for(var i = 0; i < total_block_and_exerc_lgth; i++) {
            var exercise_el = sorted_blocks_exercs_order_arr[i][1]; // 0 = block_id; 1 = exercise object (ie name, set_id, etc...)
            var total_exerc_lgth = exercise_el.length;

            var tmp_set_id_arr  = [];

            for (var j = 0; j < total_exerc_lgth; j++) {
                var tmp_set_id = exercise_el[j];
                tmp_set_id_arr.push(tmp_set_id)
            }
            tmp_exerc_arr.push(tmp_set_id_arr);
        }

        var tmp_arr = [];
        //// COMPARE DAY IDS AND FETCH NEW DAY ID TO ITS DAY ORDER
        for(var key in programObj) {
                var value        = programObj[key];
                var day_id       = value.day_id;
                var block_id     = value.block_id;
                var block_name   = value.block_name;
                var exercise     = value.exercise;

                // fetch the week and day order
                if(day_id_to === day_id) {
                    match_week_id    = value.week_id;
                    match_week_order = value.week_order;
                    match_day_order  = value.day_order;
                }

                var block_index   = sorted_blocks_order.indexOf(block_id);

                for(var key1 in exercise) {
                    var exer        = exercise[key1];
                    var set_id      = exer.set_id;

                    var result = getIndexOfK(tmp_exerc_arr, set_id);
                    if(result != undefined) {

                            var tmp_block_index    = result[0];
                            var tmp_exercise_index = result[1];

                            if(tmp_arr[tmp_block_index] === undefined)
                                tmp_arr[tmp_block_index] = {};
                            if(tmp_arr[tmp_block_index].exercise === undefined)
                                tmp_arr[tmp_block_index].exercise = {}
                            if(tmp_arr[tmp_block_index].exercise[tmp_exercise_index] === undefined)
                                tmp_arr[tmp_block_index].exercise[tmp_exercise_index] = {}

                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].name       = exer.name;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].set_id     = exer.set_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].id         = exer.id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].order      = exer.order;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].rest       = exer.rest;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].youtube_id = exer.youtube_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].notes      = exer.notes;

                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].advanced_metrics = exer.advanced_metrics;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_1_id  = exer.row_1_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_2_id  = exer.row_2_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_3_id  = exer.row_3_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_4_id  = exer.row_4_id;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_1_arr = exer.row_1_arr;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_2_arr = exer.row_2_arr;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_3_arr = exer.row_3_arr;
                            tmp_arr[tmp_block_index].exercise[tmp_exercise_index].row_4_arr = exer.row_4_arr;
                    }
                }
        }

        //// LOOP AND INSERT THE SORTED BLOCKS/ELEMENTS ////
        for(var key in programObj) {
                var value        = programObj[key];
                var week_id      = value.week_id;
                var week_order   = value.week_order;
                var day_id       = value.day_id;
                var day_order    = value.day_order; //sorted_days_order.indexOf(day_id) + 1; //day order starts at 1, not 0;
                var new_block_order;
                var block_name   = value.block_name;
                var exercise     = value.exercise;
                var block_id     = value.block_id;
                var exercise_lgth = value.exercise_lgth;

                var block_index   = sorted_blocks_order.indexOf(block_id)
                n_ctr = block_index;

                // BLOCK MATCH
                new_block_order = block_index;// temp rem: 2/10 - block_to_index+1;
                week_id         = match_week_id;
                week_order      = match_week_order; // Must Assign New Week Order if Block Moved to Another Week
                day_id          = day_id_to;
                day_order       = match_day_order; // Must Assign New Day Order if Block Moved to Another Day

                //// COPY EXISTING BLOCKS IN A MATCHING DAY ////
                tmpObj[n_ctr] = {};
                tmpObj[n_ctr].week_id       = week_id;
                tmpObj[n_ctr].week_order    = week_order;
                tmpObj[n_ctr].day_id        = day_id;
                tmpObj[n_ctr].day_order     = day_order;
                tmpObj[n_ctr].block_id      = block_id;
                tmpObj[n_ctr].block_order   = new_block_order;
                tmpObj[n_ctr].block_name    = block_name;
                tmpObj[n_ctr].exercise      = exercise;
                tmpObj[n_ctr].exercise      = {};

                // Add conditional if an exercise is dragged outside of a block and the block is empty
                if(tmp_arr[n_ctr] != undefined) {
                        var tmp_exerc_lgth  = Object.keys(tmp_arr[n_ctr].exercise).length;

                        for(var l = 0; l < tmp_exerc_lgth; l++) {
                            var tmp_name = tmp_arr[n_ctr].exercise[l].name;
                            var exer     = tmp_arr[n_ctr].exercise[l];

                            tmpObj[n_ctr].exercise[l]                  = {};
                            tmpObj[n_ctr].exercise[l].id               = exer.id;

                            tmpObj[n_ctr].exercise[l].name             = exer.name;
                            tmpObj[n_ctr].exercise[l].set_id           = exer.set_id;
                            tmpObj[n_ctr].exercise[l].order            = exer.order;
                            tmpObj[n_ctr].exercise[l].rest             = exer.rest;
                            tmpObj[n_ctr].exercise[l].youtube_id       = exer.youtube_id;
                            tmpObj[n_ctr].exercise[l].notes            = exer.notes;

                            tmpObj[n_ctr].exercise[l].advanced_metrics = exer.advanced_metrics;
                            tmpObj[n_ctr].exercise[l].row_1_id         = exer.row_1_id;
                            tmpObj[n_ctr].exercise[l].row_2_id         = exer.row_2_id;
                            tmpObj[n_ctr].exercise[l].row_3_id         = exer.row_3_id;
                            tmpObj[n_ctr].exercise[l].row_4_id         = exer.row_4_id;
                            tmpObj[n_ctr].exercise[l].row_1_arr        = exer.row_1_arr;
                            tmpObj[n_ctr].exercise[l].row_2_arr        = exer.row_2_arr;
                            tmpObj[n_ctr].exercise[l].row_3_arr        = exer.row_3_arr;
                            tmpObj[n_ctr].exercise[l].row_4_arr        = exer.row_4_arr;
                        }

                        tmpObj[n_ctr].exercise_lgth = tmp_exerc_lgth;
                }
        }

        tmpObj = tmpObj.sort(propSorter(['week_order','day_order','block_order']));
        //testKeys(tmpObj);
        console.log(" -- End SORT BLOCK OBJECT function --");
        return tmpObj;
}

export const sortBlockObjectFromMonthView = (programObj, sorted_blocks_order, block_id_to, day_id, day_id_to, block_to_index) => {
        var n_ctr  = 0;
        var tmpObj = [];
        var match_week_id;
        var match_week_order;
        var match_day_order;
        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<< SORT MONTH VIEW BLOCK OBJECT function >>>>>>>>>>>>>>>>>>>>>>>>>>>>");

        //console.log("programObj LENGTH: " + Object.keys(programObj).length);

        //// COMPARE DAY IDS AND FETCH NEW DAY ID TO ITS DAY ORDER
        for(var key in programObj) {
                var value        = programObj[key];
                var day_id       = value.day_id;

                // fetch the week and day order
                if(day_id_to === day_id) {
                    //console.log("HIT ONCE!!!");
                    match_week_id    = value.week_id;
                    match_week_order = value.week_order;
                    match_day_order  = value.day_order;
                }
        }

        //// LOOP AND INSERT THE SORTED BLOCKS/ELEMENTS ////
        for(var key in programObj) {
                var value        = programObj[key];
                var week_id      = value.week_id;
                var week_order   = value.week_order;
                var day_id       = value.day_id;
                var day_order    = value.day_order; //sorted_days_order.indexOf(day_id) + 1; //day order starts at 1, not 0;
                var new_block_order = value.block_order;
                var block_name   = value.block_name;
                var exercise     = value.exercise;
                var block_id     = value.block_id;
                var exercise_lgth = value.exercise_lgth;

                //console.log("-------------- key: " + key + " - new_block_order: " + new_block_order);

                if(block_id === block_id_to) {
                    // BLOCK MATCH
                    new_block_order = block_to_index+1;
                    week_id         = match_week_id;
                    week_order      = match_week_order; // Must Assign New Week Order if Block Moved to Another Week
                    day_id          = day_id_to;
                    day_order       = match_day_order; // Must Assign New Day Order if Block Moved to Another Day
                    //console.log("Block Match!");
                }

                else if(day_id === day_id_to) {
                    new_block_order    = sorted_blocks_order.indexOf(block_id) + 1; // block index starts @ 0 element
                    day_id = day_id_to; // if block has been sorted to a new day
                    //console.log("DAY MATCH!!!");
                }

                //// COPY EXISTING BLOCKS IN A MATCHING DAY ////
                tmpObj[n_ctr] = {};
                tmpObj[n_ctr].week_id       = week_id;
                tmpObj[n_ctr].week_order    = week_order;
                tmpObj[n_ctr].day_id        = day_id;
                tmpObj[n_ctr].day_order     = day_order;
                tmpObj[n_ctr].block_id      = block_id;
                tmpObj[n_ctr].block_order   = new_block_order;
                tmpObj[n_ctr].block_name    = block_name;
                tmpObj[n_ctr].exercise      = exercise;
                tmpObj[n_ctr].exercise_lgth = exercise_lgth;
                tmpObj[n_ctr].exercise   = {};

                for(var key1 in exercise) {
                    var exer        = exercise[key1];
                    var exer_name   = exer.name;
                    var exer_id     = exer.id;
                    var set_id      = exer.set_id;
                    var exer_order  = exer.order;
                    var youtube_id  = exer.youtube_id;
                    var notes       = exer.notes;

                    var advanced_metrics = exer.advanced_metrics;
                    var row_1_id         = exer.row_1_id;
                    var row_2_id         = exer.row_2_id;
                    var row_3_id         = exer.row_3_id;
                    var row_4_id         = exer.row_4_id;
                    var row_1_arr        = exer.row_1_arr;
                    var row_2_arr        = exer.row_2_arr;
                    var row_3_arr        = exer.row_3_arr;
                    var row_4_arr        = exer.row_4_arr;

                    //console.log("exer_name: " + exer_name);
                    //console.log("advanced_metrics: " + advanced_metrics);
                    tmpObj[n_ctr].exercise[key1]   = {};
                    tmpObj[n_ctr].exercise[key1].id = exer_id;
                    tmpObj[n_ctr].exercise[key1].name = exer_name;
                    tmpObj[n_ctr].exercise[key1].set_id = set_id;
                    tmpObj[n_ctr].exercise[key1].order = exer_order;
                    tmpObj[n_ctr].exercise[key1].notes = notes;

                    tmpObj[n_ctr].exercise[key1].row_1_id         = row_1_id;
                    tmpObj[n_ctr].exercise[key1].row_2_id         = row_2_id;
                    tmpObj[n_ctr].exercise[key1].row_3_id         = row_3_id;
                    tmpObj[n_ctr].exercise[key1].row_4_id         = row_4_id;
                    tmpObj[n_ctr].exercise[key1].row_1_arr        = row_1_arr;
                    tmpObj[n_ctr].exercise[key1].row_2_arr        = row_2_arr;
                    tmpObj[n_ctr].exercise[key1].row_3_arr        = row_3_arr;
                    tmpObj[n_ctr].exercise[key1].row_4_arr        = row_4_arr;

                    /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
                }

                n_ctr++;
        }

        tmpObj = tmpObj.sort(propSorter(['week_order','day_order','block_order'])); //'week_order'
        //testKeys(tmpObj);

        return tmpObj;
}

function sortByExercOrder(a, b) {
    if (a[3] === b[3]) {
        return 0;
    }
    else {
        return (a[3] < b[3]) ? -1 : 1;
    }
}

function multiDimensionalUnique(arr) {
    var uniques = [];
    var itemsFound = {};
    for(var i = 0, l = arr.length; i < l; i++) {
        var stringified = JSON.stringify(arr[i]);
        if(itemsFound[stringified]) { continue; }
        uniques.push(arr[i]);
        itemsFound[stringified] = true;
    }

    return uniques;
}

/*
function setNewSortExerciseArray(programObj, block_id_to, exercises_order, exercise_to_index, new_set_id, new_exer_id, new_exer_name, tmpSingleObj) {
    var exerc_arr = [];
    var sorted_flag = false;
    var match_week_id;
    var match_week_order;
    var match_day_id;
    var match_day_order;
    var match_block_id;
    var match_block_order;
    var matchObj = {};
    console.log("------------------------  1. ADD EXERCISE Id's HERE! ------------------------------");
    //// COMPARE BLOCK IDS AND SORT NEW EXERCISE ORDERS
    for(var key in programObj) {
            var value        = programObj[key];
            var day_id       = value.day_id;
            var block_id     = value.block_id;
            var exercise     = value.exercise;

            // fetch the week, day and block data
            if(block_id === block_id_to) {
                matchObj.match_week_id     = value.week_id;
                matchObj.match_week_order  = value.week_order;
                matchObj.match_day_id      = day_id;
                matchObj.match_day_order   = value.day_order;
                matchObj.match_block_id    = block_id_to;
                matchObj.match_block_order = value.block_order;

                // Create New Exercise Array and then Sort belo //
                for(var key1 in exercise) {
                    var exer        = exercise[key1];

                    var exer_name   = exer.name;
                    var exer_id     = exer.id;
                    var set_id      = exer.set_id;
                    var exer_order  = exer.order;
                    var rest        = exer.rest;
                    var youtube_id  = exer.youtube_id;
                    var notes       = exer.notes;

                    var advanced_metrics = exer.advanced_metrics;
                    var row_1_id         = exer.row_1_id;
                    var row_2_id         = exer.row_2_id;
                    var row_3_id         = exer.row_3_id;
                    var row_4_id         = exer.row_4_id;
                    var row_1_arr        = exer.row_1_arr;
                    var row_2_arr        = exer.row_2_arr;
                    var row_3_arr        = exer.row_3_arr;
                    var row_4_arr        = exer.row_4_arr;
                    exer_order  = exercises_order.indexOf(set_id) + 1; // start at element of 1

                    if(key1 == exercise_to_index) {
                        var tmp_order = exercise_to_index+1;
                        //// Push Newly Sorted Exercise onto Array
                        // temp remove 2/6: it adds a duplicate value
                        //  exerc_arr.push([new_set_id, new_exer_id, new_exer_name, tmp_order, rest, youtube_id, notes, advanced_metrics, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr])
                        sorted_flag = true;
                    }

                    exerc_arr.push([set_id, exer_id, exer_name, exer_order, rest, youtube_id, notes, advanced_metrics, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr])
                }
            }
    }

    //// If the newly sorted exercise is placed as the last exercise in a Block and not inserted above ////
    if(!sorted_flag) {
        exerc_arr.push([new_set_id, new_exer_id, new_exer_name, exercise_to_index, rest, youtube_id, notes, advanced_metrics, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr])
    }

    matchObj.exerc_arr = exerc_arr;
    matchObj.sorted_flag = sorted_flag;

    return matchObj;
}*/


function testKeys(tmpObj) {
    console.log("****************************** TEST SORT *****************************************");
    Object.keys(tmpObj).map(function(key, index) {
        console.log("--------------- key: " + key);
        console.log("week id:     " + tmpObj[key].week_id);
        console.log("week order:  " + tmpObj[key].week_order);
        console.log("day id:      " + tmpObj[key].day_id);
        console.log("day order:   " + tmpObj[key].day_order);
        //console.log("block id:    " + tmpObj[key].block_id);
        //console.log("block order: " + tmpObj[key].block_order);
        var exercise = tmpObj[key].exercise;
        for(var key1 in exercise) {
            var exer            = exercise[key1];
            var exer_name       = exer.name;
            var exer_id         = exer.id;
            var set_id          = exer.set_id;
            var exer_order      = exer.order;
            console.log(key1 + ". exer.order: " +  exer.order);
            console.log("exer_name: " + exer_name);
            //console.log("set_id: " + set_id);

            /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
        }
    });
}

//Prepend minus to specify descending order.
// tmpObj.sort(fieldSorter(['name', '-week_order', 'block_id']));
function propSorter(fields) {
      var dir = [], i, l = fields.length;
      fields = fields.map(function(o, i) {

        if (o[0] === "-") {
          dir[i] = -1;
          o = o.substring(1);
        } else {
          dir[i] = 1;
        }
        return o;
      });

      return function (a, b) {
        for (i = 0; i < l; i++) {
          var o = fields[i];
          if (a[o] > b[o]) return dir[i];
          if (a[o] < b[o]) return -(dir[i]);
        }
        return 0;
      };
}

/*
        //tmpObj = tmpObj.sort(compareWeekOrders).sort(compareDayOrders).sort(compareBlockOrders);
function compareBlockOrders(a, b){
    let comparison = 0;

    if (a.block_order > b.block_order) comparison = 1;
      else if (b > a) comparison = -1;

    return comparison;
}

function compareDayOrders(a, b){
    let comparison = 0;

    if (a.day_order > b.day_order) comparison = 1;
      else if (b > a) comparison = -1;

    return comparison;
}

function compareWeekOrders(a, b){
    let comparison = 0;

    if (a.week_order > b.week_order)
          comparison = 1;
    else if (b > a)
          comparison = -1;

    return comparison;
}*/

function addNormalObject(tmpObj, oldObj, tmpObj_ctr) {
    var oldObj_lgth  = Object.keys(oldObj).length;
    //// Reconsolidate the Non-matching (original) Objects
    for(var m = 0; m < oldObj_lgth; m++) {
            var week_id       = oldObj[m].week_id;
            var week_order    = oldObj[m].week_order;
            var day_id        = oldObj[m].day_id;
            var day_order     = oldObj[m].day_order; // order ???
            var block_order   = oldObj[m].block_order;
            var block_id_new  = oldObj[m].block_id;
            var block_name    = oldObj[m].block_name;
            var exercise      = oldObj[m].exercise;
            var exercise_lgth = oldObj[m].exercise_lgth;
            /*console.log("----------------------");
            console.log("week_id: " + week_id);
            console.log("week_order: " + week_order);
            console.log("day_id: " + day_id);/* */

            for(var key_e2 in exercise) {
                var exer            = exercise[key_e2];
                var exer_name       = exer.name;
                var exer_id         = exer.id;
                //console.log("**** exer_name: " + exer_name);
            }
            var tmpObj = addObj(tmpObj_ctr, tmpObj, week_id, day_id, week_order, day_order, block_order, block_id_new, block_name, exercise, exercise_lgth);
            tmpObj_ctr++;
    }

    return tmpObj;
}
function addNewObj(tmpObj_ctr, el_ctr, tmpObj, newObj, day_id_to){
        //day_id_to: argument; //block_id: argument
        var obj_lgth = Object.keys(newObj).length;
        //console.log("******** add NEW Obj() *********");

        var i = el_ctr;

        var week_id       = newObj[i].week_id;
        var week_order    = newObj[i].week_order;
        var day_order     = newObj[i].day_order;
        var block_id      = newObj[i].block_id;
        var block_order   = newObj[i].block_order;
        var block_name    = newObj[i].block_name;
        var exercise      = newObj[i].exercise;
        var exercise_lgth = newObj[i].exercise_lgth;
        //console.log("---- Add new obj ctr: " + i);

        //// TEMP TEST ////
        /*if(day_id_to === "54c673a8-39e6-11e8-b39c-530c927810fe") {
            console.log("INSERT NEW DATA NOW!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
            week_id = "54c527d2-39e6-11e8-b39b-dff271dc1e33";
        }*/

        tmpObj = addObj(tmpObj_ctr, tmpObj, week_id, day_id_to, week_order, day_order, block_order, block_id, block_name, exercise, exercise_lgth);

        return tmpObj;
}

function addObj(tmpObj_ctr, tmpObj, week_id, day_id_to, week_order, day_order, block_order, block_id, block_name, exercise, exercise_lgth) {
        //var tmpObj2 = {};
        tmpObj[tmpObj_ctr] = {};
        tmpObj[tmpObj_ctr].week_id       = week_id;
        tmpObj[tmpObj_ctr].week_order    = week_order;
        tmpObj[tmpObj_ctr].day_id        = day_id_to;
        tmpObj[tmpObj_ctr].day_order     = day_order;
        tmpObj[tmpObj_ctr].block_order   = block_order;
        tmpObj[tmpObj_ctr].block_id      = block_id;
        tmpObj[tmpObj_ctr].block_name    = block_name;
        tmpObj[tmpObj_ctr].exercise      = exercise;
        tmpObj[tmpObj_ctr].exercise_lgth = exercise_lgth;
        //console.log("----------- add Obj() ----------");
        //console.log("day_order: " + day_order);

        for(var key_e in exercise) {
            var exer            = exercise[key_e];
            var exer_name       = exer.name;
            var exer_id         = exer.id;
            var set_id          = exer.set_id;
            //console.log("exer_name: " + exer_name);
            tmpObj[tmpObj_ctr].exercise[key_e] = {};
            tmpObj[tmpObj_ctr].exercise[key_e].id = exer_id;
            tmpObj[tmpObj_ctr].exercise[key_e].name = exer_name;
            tmpObj[tmpObj_ctr].exercise[key_e].set_id = set_id;
            // add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
        }

        return tmpObj;
}

export const old_sortBlockObjectFromMonthView = (programObj, day_id_to, day_id_from, block_id, block_index_pos) => {
        var ctr  = 0;
        var ctr2 = 0;
        var tmpObj     = {};//programObj;
        var currObj    = {};
        var newObj     = {};
        var tmpProgObj = programObj;
        var programObj_lgth = Object.keys(programObj).length;
        //console.log("<<<<<<<<<<<<<<<<< RUNNING function >>>>>>>>>>>>>>>>");
        var week_id;
        //// LOOP AND REMOVE THE SORTED BLOCKS/ELEMENTS ////

        var day_order;
        for(var key in programObj) {
                var value         = programObj[key];
                week_id           = value.week_id;
                var week_order    = value.week_order;
                day_order         = value.day_order;
                var day_id_tmp    = value.day_id;
                var block_order   = value.block_order;
                var block_name    = "";
                var exercise      = value.exercise;
                var block_id_tmp  = value.block_id;
                var exercise_lgth = value.exercise_lgth;
                //var b_lgth        = block_id_order.length;
                var flag_unused = 1;

                //// COPY EXISTING BLOCKS IN A MATCHING DAY ////
                if(day_id_tmp === day_id_to) {
                        if(block_id != block_id_tmp) {
                                /*currObj[ctr2] = {};
                                currObj[ctr2].day_id        = day_id_to; // add new day id
                                currObj[ctr2].day_order     = day_order;
                                currObj[ctr2].block_order   = block_order;
                                currObj[ctr2].week_id       = week_id;
                                currObj[ctr2].block_id      = block_id_tmp; // add new block_id
                                currObj[ctr2].block_name    = block_name;
                                currObj[ctr2].exercise      = exercise;
                                currObj[ctr2].exercise_lgth = exercise_lgth;

                                currObj[ctr2].exercise   = {};
                                for(var key2 in exercise) {
                                    var exer            = exercise[key2];
                                    var exer_name       = exer.name;
                                    var exer_id         = exer.id;
                                    var set_id          = exer.set_id;

                                    currObj[ctr2].exercise[key2]   = {};
                                    currObj[ctr2].exercise[key2].id = exer_id;
                                    currObj[ctr2].exercise[key2].name = exer_name;
                                    currObj[ctr2].exercise[key2].set_id = set_id;
                                    /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
                                }*/
                                currObj = addObj(ctr2, currObj, week_id, day_id_to, week_order, day_order, block_order, block_id_tmp, block_name, exercise, exercise_lgth);
                                ctr2++;
                        }

                        // Skip Over Next Step
                        flag_unused = 0;
                }

                if(block_id === block_id_tmp) {
                        newObj[0] = {};
                        newObj[0].day_id        = day_id_to; // add new day id
                        newObj[0].day_order     = day_order;
                        newObj[0].block_order   = block_order;
                        newObj[0].week_id       = week_id;
                        newObj[0].week_order    = week_order;
                        newObj[0].block_id      = block_id; // add new block_id
                        newObj[0].block_name    = block_name;
                        newObj[0].exercise      = exercise;
                        newObj[0].exercise_lgth = exercise_lgth;
                        newObj[0].exercise   = {};

                        for(var key1 in exercise) {
                            var exer            = exercise[key1];
                            var exer_name       = exer.name;
                            var exer_id         = exer.id;
                            var set_id          = exer.set_id;

                            newObj[0].exercise[key1]   = {};
                            newObj[0].exercise[key1].id = exer_id;
                            newObj[0].exercise[key1].name = exer_name;
                            newObj[0].exercise[key1].set_id = set_id;

                            /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
                        }
                        // Skip Over Next Step
                        flag_unused = 0;
                }

                if(flag_unused) {
                        // Maintain Order of ALL Other Blocks
                        //tmpObj[ctr] = {};
                        //tmpObj[ctr].day_id        = day_id_tmp;
                        //tmpObj[ctr].day_order     = day_order;
                        //tmpObj[ctr].block_order   = block_order;
                        //tmpObj[ctr].week_id       = week_id;
                        //tmpObj[ctr].block_id      = block_id_tmp;
                        //tmpObj[ctr].block_name    = block_name;
                        /*tmpObj[ctr].exercise      = exercise;
                        tmpObj[ctr].exercise_lgth = exercise_lgth;
                        tmpObj[ctr].exercise      = {};

                        for(var key3 in exercise) {
                            var exer            = exercise[key3];
                            var exer_name       = exer.name;
                            var exer_id         = exer.id;
                            var set_id          = exer.set_id;

                            tmpObj[ctr].exercise[key3]   = {};
                            tmpObj[ctr].exercise[key3].id = exer_id;
                            tmpObj[ctr].exercise[key3].name = exer_name;
                            tmpObj[ctr].exercise[key3].set_id = set_id;
                        }*/
                        tmpObj = addObj(ctr, tmpObj, week_id, day_id_tmp, week_order, day_order, block_order, block_id_tmp, block_name, exercise, exercise_lgth);
                        ctr++;
                }
        }

        //// STEP 2. LOOP AGAIN AND ADD IN SORTED BLOCKS/ELEMENTS ////
        var tmpObj_lgth = Object.keys(tmpObj).length;
        var newObj_lgth = Object.keys(currObj).length; // + 1 is for newObj

        var ctr3        = tmpObj_lgth;
        var new_flag    = 1;

        for(var l = 0; l < newObj_lgth; l++) {
                if(block_index_pos === l && new_flag) {
                        // Append New Obj Data to Previous TmpObj which holds eisting block data
                        tmpObj = addNewObj(ctr3, 0, tmpObj, newObj, day_id_to);
                        l--;
                        new_flag = 0;
                } else {
                        var week_id       = currObj[l].week_id;
                        var week_order    = currObj[l].week_order;
                        var day_id        = currObj[l].day_id;
                        var day_order     = currObj[l].day_order;
                        var block_order   = currObj[l].block_order;
                        var block_id_new  = currObj[l].block_id;
                        var block_name    = currObj[l].block_name;
                        var exercise      = currObj[l].exercise;
                        var exercise_lgth = currObj[l].exercise_lgth;
                        tmpObj = addObj(ctr3, tmpObj, week_id, day_id, week_order, day_order, block_order, block_id_new, block_name, exercise, exercise_lgth);
                }
                ctr3++;
        }

        //// In case New Block Object Still hasn't Been Added to the TmpObj Yet   ////
        //// For example, if a block is dragged into the last block spot of a day ////
        if(new_flag) tmpObj = addNewObj(ctr3, 0, tmpObj, newObj, day_id_to);

        return tmpObj;

}

export const old_sortWeekObjectFromMonthView = (programObj, sorted_week_order, week_id_to, week_id_from, sorted_week_id, new_index) => {
    var ctr  = 0;
    var ctr2 = 0;
    var n_ctr = 0;
    var order_ctr = 1;
    var currObj    = {};
    var newObj     = {};
    var tmpProgObj = programObj;
    var programObj_lgth = Object.keys(programObj).length;

    console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<< SORT WEEK OBJECT function >>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    var week_id;
    var day_order;

    var move_week_to = sorted_week_order[0];
    console.log("week_order: " + sorted_week_order);

    //// LOOP AND REMOVE THE SORTED BLOCKS/ELEMENTS ////
    for(var key in programObj) {
            var value        = programObj[key];
            week_id          = value.week_id;
            //var week_order   = value.week_order;
            var new_week_order= sorted_week_order.indexOf(week_id) + 1;
            var day_order    = value.day_order;
            var day_id       = value.day_id;
            var block_order  = value.block_order;
            var block_name   = "";
            var exercise     = value.exercise;
            var block_id     = value.block_id;
            var exercise_lgth = value.exercise_lgth;
            //var b_lgth        = block_id_order.length;
            var flag_unused = 1;

            console.log("******************* TEST ******************");
            console.log("week_id: " + week_id);
            console.log("day_order: " + day_order);
            console.log("move_week_to: " + move_week_to);

            //// Step 1. Do Week Ids Match or Did a Day move/sort to another week
            if(week_id === move_week_to) {
                    console.log("***** Matching WEEK! *****")
                    console.log("move_week_to: " + move_week_to);
                    console.log("day_id: " + day_id);
                    //// COPY EXISTING BLOCKS IN A MATCHING DAY ////
                    newObj[n_ctr] = {};
                    newObj[n_ctr].week_id       = move_week_to;//week_id_to;//week_id;
                    newObj[n_ctr].week_order    = new_week_order;
                    newObj[n_ctr].day_id        = day_id; //change when day sprted >> add new day id
                    newObj[n_ctr].day_order     = day_order; // since day orders start @ 1
                    newObj[n_ctr].block_order   = block_order;
                    newObj[n_ctr].block_id      = block_id; // add new block_id
                    newObj[n_ctr].block_name    = block_name;
                    newObj[n_ctr].exercise      = exercise;
                    newObj[n_ctr].exercise_lgth = exercise_lgth;
                    newObj[n_ctr].exercise   = {};

                    for(var key1 in exercise) {
                        var exer            = exercise[key1];
                        var exer_name       = exer.name;
                        var exer_id         = exer.id;
                        var set_id          = exer.set_id;
                        //console.log("exer_name: " + exer_name);
                        newObj[n_ctr].exercise[key1]   = {};
                        newObj[n_ctr].exercise[key1].id = exer_id;
                        newObj[n_ctr].exercise[key1].name = exer_name;
                        newObj[n_ctr].exercise[key1].set_id = set_id;

                        /// add below props laterset_id = uuidv1(); m_a_id; m_a_value; m_b_id; m_b_value; rest; notes;
                    }
                    n_ctr++;
            } else {
                    console.log("***** NO MATCHING WEEK! *****");
                    console.log("week_id: " + week_id);
                    console.log("day_id: " + day_id);
                    //// If Same week but Day (that is not matching) is moved,
                    //// Multiple days can be in a different order in the TmpObject, so we must detect where each
                    //// day is located in the "days_order" argument

                    currObj = addObj(ctr2, currObj, week_id, day_id, new_week_order, day_order, block_order, block_id, block_name, exercise, exercise_lgth);
                    ctr2++;
                    // Skip Over Next Step
                    flag_unused = 0;
                    // increase counter by 1 since day has been found and matched!

                    order_ctr++;
            }
    }

    console.log("=============================== COMBINE SORT WEEKS ===============================");
    //var tmpObj_lgth  = Object.keys(tmpObj).length;
    var newObj_lgth  = Object.keys(newObj).length;
    var currObj_lgth = Object.keys(currObj).length;

    var tmpObj     = {};//programObj;
    var tmpObj_ctr        = 0;//tmpObj_lgth;
    var currObj_ctr       = 0;
    var skip_new_obj_flag = 1;
    var new_flag          = 1;
    var week_index        = new_index + 1; //starts at 0 index
    var weeks_order_lgth  = sorted_week_order.length;
    var obj_lgth          = currObj_lgth+1; // If the Newly Sorted Day is not the last Day in a Week
    var curr_week_id;

    if(week_index === weeks_order_lgth) {
        skip_new_obj_flag = 0; // skip the ability to add new objects within the for loop below
        obj_lgth = currObj_lgth; // remove +1 since the day is last in the week after being sorted
    }

    for(var l = 0; l < obj_lgth; l++) { // +1 = newObj

            // We add +1 to above obj_lgth to include the new Obj, but we need to ensure
            // the currObj is not looped through entirely, so we only loop current Objects

            //if(curr_week_id == week_id_to) {
                    //console.log("NEW INDEX: " + new_index);
                    //// 1. ADD HERE
                    if(new_index === l && skip_new_obj_flag) {
                            console.log(l + ". ------------- ADD NEW OBJECT -------------");
                            console.log("tmpObj_ctr. " + tmpObj_ctr);
                            // Append New Obj Data to Previous TmpObj which holds eisting block data
                            // If loop is missing, each SORTED DAY will ONLY SHOW 1 set in a day
                            for(var n = 0; n < newObj_lgth; n++) {
                                var day_id = newObj[n].day_id;
                                var test = newObj[n].week_id;
                                console.log("******* TEST Check week ids: " + test);
                                tmpObj = addNewObj(tmpObj_ctr, n, tmpObj, newObj, day_id);
                                tmpObj_ctr++;
                            }
                            // 2. MUST LOOP THROUGH TMP OBJ HERE
                            new_flag = 0;
                    } else {
                            console.log(l + ". ----------- *********  ADD EXISTING OBJECT -----------");
                            console.log("tmpObj_ctr. " + tmpObj_ctr);
                            var week_id       = currObj[currObj_ctr].week_id;
                            var week_order    = currObj[currObj_ctr].week_order;
                            var day_id        = currObj[currObj_ctr].day_id;
                            var day_order     = currObj[currObj_ctr].day_order; // order ???
                            var block_order   = currObj[currObj_ctr].block_order;
                            var block_id_new  = currObj[currObj_ctr].block_id;
                            var block_name    = currObj[currObj_ctr].block_name;
                            var exercise      = currObj[currObj_ctr].exercise;
                            var exercise_lgth = currObj[currObj_ctr].exercise_lgth;
                            for(var key_e in exercise) {
                                var exer            = exercise[key_e];
                                var exer_name       = exer.name;
                                var exer_id         = exer.id;
                                //console.log("**** exer_name: " + exer_name);
                            }
                            tmpObj = addObj(tmpObj_ctr, tmpObj, week_id, day_id, week_order, day_order, block_order, block_id_new, block_name, exercise, exercise_lgth);
                            currObj_ctr++;/* */
                            tmpObj_ctr++;
                    }
            //}
    }

    //// In case New Day Object Still hasn't Been Added to the TmpObj Yet   ////
    //// For example, if a Day is dragged into the last Day spot of a Week ////

    if(new_flag) {
        for(var n = 0; n < newObj_lgth; n++) {
            //console.log("................. N Ctr: " + n + " .................");
            //console.log("tmpObj_ctr: " + tmpObj_ctr);
            var day_id = newObj[n].day_id;
            tmpObj = addNewObj(tmpObj_ctr, n, tmpObj, newObj, day_id);
            tmpObj_ctr++;
        }
    }

    return tmpObj;
}



// WEBPACK FOOTER //
// ./src/utils/ObjectSort.js